<template>
  <div class="container">
    <template v-if="$router.history.current.name === 'gettingstarted'">
      <div class="row">
        <div class="col-12">
          <h1>Getting started!</h1>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <p>
            This page will help you get started in minescape if you don't know what you want to do. Please note that you
            should play the game whichever way you want and that you do not need to do what other people say. That being
            said, if you don't know where to start, this page can give you some useful tips to get started with your
            minescape adventure.
          </p>
        </div>
      </div>

      <div class="row mt-5">
        <div class="col-12 text-center">
          <h3>Select an article below to learn more about how to get started in minescape</h3>
        </div>
      </div>

      <div class="row" v-if="articles !== null">
        <div class="col-4 p-2" v-for="article in articles" :key="article.slug">
          <div class="card border-dark article" @click="visit(article.slug)">
            <img class="article-image" :src="article.thumb_image">

            <div class="card-body">
              <h4>{{ article.thumb_title }}</h4>
              <p>{{ article.thumb_description }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="row">
        <div class="col-12 text-center">
          <div class="spinner-border text-dark"></div>
        </div>
      </div>

    </template>

    <div class="row">
      <div class="col-12">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
import {articles} from "@/utility/APIClient";

export default {
  name: "GettingStarted",

  data: function () {
    return {
      articles: null,
    }
  },

  created() {
    articles.get_thumbs()
      .then(result => {
        this.articles = result.data;
      });
  },

  methods: {
    visit(slug) {
      this.$router.push({
        name: 'gettingstartedarticle',
        params: {
          article: slug
        }
      })
    }
  }
}
</script>

<style scoped>

.article {
  height: 400px;
  background-color: #0f1823;

  transition: transform 0.5s;
}

.article-image {
  width: 100%;
  height: 150px;

  object-fit: cover;

  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}

.article:hover {
  transform: scale(1.07);
  cursor: pointer;
}

</style>